import { useGetProfileContractQuery } from 'features/api/apiSlice';
import { useSendInfoMutation } from 'features/api/userSlice';
import { useInternalSession } from 'hooks/useInternalSession';
import { useCallback } from 'react';
import { TIPOLOGY_SEND_INFO } from 'utility/dashboard/constants';

type SendVoucherSmsParams = {
  textSms: string;
  importo: string;
  transactionDate: string;
  expirationDate: string;
  idBigl: string;
};
export const useSendSms = (params: SendVoucherSmsParams) => {
  const {
    session: { user },
  } = useInternalSession();
  const [sendInfo] = useSendInfoMutation();
  const { data: profileContractResponse } = useGetProfileContractQuery(user?.csmfCod, {
    selectFromResult: (response) => ({
      ...response,
      data: {
        telefonoMobile: response.data?.telefonoMobile,
        fiscalCode: response.data?.cf,
      },
    }),
  });

  const sendSms = useCallback(async () => {
    if (profileContractResponse) {
      const text = params.textSms
        ?.replace('{{ID_VOUCHER}}', params.idBigl)
        .replace('{{CONTRACT_CODE}}', user?.contractCode ?? '')
        .replace('{{FISCAL_CODE}}', profileContractResponse.fiscalCode ?? '')
        .replace('{{AMOUNT}}', params.importo)
        .replace('{{DATE}}', params.transactionDate)
        .replace('{{EXPIRE_DATE}}', params.expirationDate);

      await sendInfo({
        to: profileContractResponse.telefonoMobile ?? '',
        text: text ?? '',
        type: TIPOLOGY_SEND_INFO.SMS,
      });
    }
  }, [
    params.expirationDate,
    params.idBigl,
    params.importo,
    params.textSms,
    params.transactionDate,
    profileContractResponse,
    sendInfo,
    user?.contractCode,
  ]);

  return sendSms;
};
